import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store';
import { iElectronicsMpnSearchState, iElectronicsMpnResponse } from 'store/types/electronicsMpnSearch';

export const initialState: iElectronicsMpnSearchState = {
    electronicsMpnSearch: null
};

export const electronicsMpnSearchSlice = createSlice({
  name: 'electronicsMpnSearch',
  initialState,
  reducers: {
    setElectronicsMpnSearch: (state, action: PayloadAction<iElectronicsMpnResponse>) => {
      // Replace the entire assembly state
        const electronicsMpnSearch: iElectronicsMpnResponse = action.payload
        state.electronicsMpnSearch = electronicsMpnSearch
    }
  }
});

// The exported reducer
export default electronicsMpnSearchSlice.reducer;
// Export the action
export const { setElectronicsMpnSearch } = electronicsMpnSearchSlice.actions;
// Optional selector
export const electronicsMpnSearchSelector = (state: RootState) =>
    state.electronicsMpnSearch.electronicsMpnSearch;